import { Controller } from "@hotwired/stimulus"
import Cleave from "cleave.js";

// Connects to data-controller="renewal-ip"
export default class extends Controller {
  static targets = [
    "advanceAmount", "hasAdvance",
    "differentPercent", "applicablePercent", "advanceHidden",
  ]
  connect() {
    if (this.hasAdvanceTarget) {
      this.toggle();
    }

    if (this.hasApplicablePercentTarget && this.hasDifferentPercentTarget) {
      this.syncApplicablePercentState(this.differentPercentTarget.checked);
    }

    const cleaveTargets = [
      "advanceAmount"
    ];

    cleaveTargets.forEach(target => {
      const hasTargetFunction = `has${target.charAt(0).toUpperCase() + target.slice(1)}Target`;
      if (this[hasTargetFunction]) {
        const inputElement = this[target + "Target"];
        // Store the current value and convert decimal point to comma if needed
        const currentValue = inputElement.value;
        const formattedValue = currentValue ? currentValue.replace('.', ',') : '';
        
        new Cleave(inputElement, {
          numeral: true,
          numeralDecimalMark: ',',
          delimiter: '.'
        });
        
        // Set the formatted value after Cleave initialization
        if (formattedValue) {
          inputElement.value = formattedValue;
        }
      }
    });
  }

  // Advance ----------------------------------------------------------------------
  toggle() {
    if (this.hasAdvanceTarget.checked) {
      this.advanceAmountTarget.closest("div.flex").classList.remove("hidden");
    } else {
      this.advanceAmountTarget.closest("div.flex").classList.add("hidden");
      this.advanceAmountTarget.value = this.advanceAmountTarget.getAttribute('data-renewal-ip-advance-value') || '';
    }
  }

  // Different Percent y Applicable Percent -----------------------------------
  togglePercent(event) {
    this.syncApplicablePercentState(event.target.checked);
  }

  syncApplicablePercentState(isChecked) {
    if (!this.hasApplicablePercentTarget) return;

    const target = this.applicablePercentTarget;
    target.disabled = !isChecked;
    if (isChecked) {
      target.classList.remove('bg-gray-200', 'cursor-not-allowed');
    } else {
      target.classList.add('bg-gray-200', 'cursor-not-allowed');
      target.value = "";
    }
    this.syncApplicablePercentHiddenField(isChecked);
  }

  syncApplicablePercentHiddenField(isChecked) {
    const input = this.applicablePercentTarget;
    const form = input.form;
    if (!form) return;

    const name = input.name;
    let hidden = form.querySelector(`input[data-applicable-percent-clear="true"][name="${name}"]`);

    if (isChecked) {
      if (hidden) hidden.remove();
      return;
    }

    if (!hidden) {
      hidden = document.createElement("input");
      hidden.type = "hidden";
      hidden.name = name;
      hidden.dataset.applicablePercentClear = "true";
      input.insertAdjacentElement("afterend", hidden);
    }
    hidden.value = "";
  }
}
